import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { UpdateService } from '../../service/update.service';
import * as qrActions from './qr.actions';

@Injectable()
export class QrEffects {
    constructor(private actions$: Actions,  private updateService: UpdateService) {
    }

    qrValidate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(qrActions.validateQRAccess),
            exhaustMap(action => this.updateService.validateQrCode(action.scheduleId, { token: action.token }).pipe(
                map((res) => qrActions.validateQRAccessSuccess({validateBooked: res})),
                catchError(error  => {
                    const responseMessage = error.error.errors[0]?.message || '';
                    const errorCode = error.error.errors[0]?.code || '';

                    return of(qrActions.validateQRAccessError({errorCode, responseMessage}));
                }
                )))
        ));

}
